module.exports = __webpack_public_path__ + "img/ios.36cb7732.png";